import CloseIcon from "../icons/AikaIcons/CloseIcon";

const AutoCompleteSelectedItem = (props: {
  onClick: () => void;
  title: string;
  disabled?: boolean;
}) => {
  const { onClick, title, disabled } = props;
  return (
    <button
      disabled={disabled}
      className="form-control d-flex justify-content-between align-items-center"
      onClick={onClick}
    >
      <span>{title}</span>
      <CloseIcon />
    </button>
  );
};

export default AutoCompleteSelectedItem;
